<template>
  <v-app class="exception">
    <v-main>
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <div class="mr-3 hidden-sm-and-down">
            <img src="/static/error/400.svg" alt />
          </div>
          <div class="text-md-center">
            <h1>400</h1>
            <h2 class="my-3 headline">Sorry, bad request.</h2>
            <div>
              <v-btn color="primary" @click="goHome">Go Home</v-btn>
            </div>
          </div>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class BadRequest extends Vue {
  goHome() {
    this.$router.push({ path: "/" });
  }
}
</script>
<style scoped lang="css">
h1 {
  font-size: 150px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow:
    rgba(61, 61, 61, 0.3) 1px 1px,
    rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
